<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'discountGoodsList' }">特惠商品</router-link>
                </li>
                <li class="active">(添加/修改)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName">
                <el-form-item label="抢购时段:">
                    <el-select @change="changFindGoods" v-model="timeId" placeholder="时段">
                        <el-option
                                v-for="item in times"
                                :key="item.id"
                                :label="item.startTime+' - '+item.endTime"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="抢购商品">
                    <el-col>
                        <el-tag
                                :key="tag.index"
                                v-for="tag in discountGoods"
                                closable
                                :disable-transitions="false"
                                @close="handleClose(tag.id)"
                                @click="discountGoodsDetail(tag.id)"
                        >
                            {{tag.name||tag.goodsName}}
                        </el-tag>
                        <span>
                            <el-tooltip content="添加商品" placement="top" effect="light">
                                 <el-button size="mini" @click="addGoods" icon="el-icon-plus" circle></el-button>
                            </el-tooltip>
                        </span>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="$router.back(-1)" size="small">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-modal">
            <select-goods ref="selectGoods" :success="changFindGoods" :goodsId="goodsId" :timeId="timeId" :times="times" ></select-goods>
        </div>
    </div>
</template>
<script>
    import selectGoods from '@/views/discount/goods-select.vue';

    export default {
        data() {
            return {
                times: [],
                discountGoods: [],
                timeId: '',
                goodsId:''
            }
        },
        created() {
            const _this = this;
            _this.findTimes();
            _this.timeId = _this.$route.query.timeId;
            _this.changFindGoods();
        },
        components: {
            selectGoods,
        },
        methods: {
            addGoods(){
                this.$refs.selectGoods.clearGoods();
                this.$refs.selectGoods.openDialog();
            },
            findTimes() {
                const _this = this;
                _this.$common.ajaxRequest({
                    url: '/seckillTime/pageSeckillTime',
                    data: {
                        limit: -1,
                    },
                    success(response) {
                        _this.times = response.items || []
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            changFindGoods() {
                const _this = this;
                _this.$common.ajaxRequest({
                    url: 'seckillGoods/pageByManager',
                    data: {
                        limit: -1,
                        seckillTimeId:_this.timeId
                    },
                    success(response) {
                        _this.discountGoods = response.items || []
                    }
                })

            },
            discountGoodsDetail(_id){
                this.goodsId = _id;
                this.$refs.selectGoods.openDialog();
            },
            handleClose(_id){
                const _this = this;
                _this.$common.ajaxRequest({
                    url: '/seckillGoods/deleteSeckillGoods',
                    data: {
                        seckillGoodsId: _id,
                    },
                    success(response) {
                        _this.changFindGoods();
                    }
                })
            }
        },
    }
</script>
<style scoped>
    .el-form-item__content .el-col {
        border: solid #b7c0b9 1px;
        border-radius: 4px;
        padding: 4px;
    }

    .el-form-item__content .el-col span {
        margin-left: 15px;
    }
</style>